<template>
  <div class="map_div">
    <baidu-map
      :center="center"
      :scroll-wheel-zoom="true"
      :zoom="zoom"
      @ready="handler"
      class="bm-view"
      @click="handClick"
      :enableMapClick="false"
      :mapClick="false"
    >
      <bm-geolocation
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :showAddressBar="true"
        :autoLocation="true"
      ></bm-geolocation>
    </baidu-map>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3,
      BMap: null,
      map: null,
      geoc: null,
      postionMap: {
        lng: 116.404,
        lat: 39.915
      },
      myMarker: null
    };
  },
  created() {},
  methods: {
    handler({ BMap, map }) {
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
      this.geoc = new BMap.Geocoder();
      this.map = map;
      this.BMap = BMap;
    },
    handClick({ type, target, point, pixel, overlay }) {
      this.setMarker(point)
      let addComp = null;
      this.geoc.getLocation(point, (rs) => {
        addComp = rs;
        this.$emit("getAddress", addComp);
      });
    },
    setMarker(point) {
      if (this.myMarker) {
        this.map.removeOverlay(this.myMarker)
      }
      this.myMarker = new BMap.Marker(new BMap.Point(point.lng, point.lat))
      
      this.map.addOverlay(this.myMarker)
    },
    setCenter(val) {
      setTimeout(() => {
        this.geoc.getPoint(val, (point) => {
        if (point) {
          this.map.centerAndZoom(point,16);
          this.setMarker(point)
        }
      }, val)
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.map_div {
  margin-top: 20px;
  .bm-view {
    width: 100%;
    height: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/ElevatorManagement/components/MapBox.vue